import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SEOOptimizedLandingPage from './components/SEOOptimizedLandingPage';
import LoginPage from './components/LoginPage';
import SignupForm from './components/SignupForm';
import VoiceSamplesPage from './components/VoiceSamplesPage';
import AudiobookAddonPage from './components/AudiobookAddonPage';
import AudiobookACXPage from './components/AudiobookACXPage';
import AudiobookVoicesPage from './components/AudiobookVoicesPage';
import HowItWorksPage from './components/HowItWorksPage';
import EditorDemoPage from './components/EditorDemoPage';
import ComparePage from './components/ComparePage';
import AuthorAiPage from './components/AuthorAiPage';
import ForAuthorsPage from './components/ForAuthorsPage';
import AboutPage from './components/AboutPage';
import AnalysisPage from './components/AnalysisPage';
import TryPage from './components/TryPage';
import HowWeReadPage from './components/HowWeReadPage';
import AuthorPersonaPage from './components/AuthorPersonaPage';
import AuthenticityPage from './components/AuthenticityPage';
import CoverStudioPage from './components/CoverStudioPage';
import WritingStudioPage from './components/WritingStudioPage';
import ApiDocsPage from './components/ApiDocsPage';
import BookPreviewerPage from './components/BookPreviewerPage';
import SocialMarketingPage from './components/SocialMarketingPage';
import CoverGalleryPage from './components/CoverGalleryPage';
import PricingPage from './components/PricingPage';
import CapabilitiesPage from './components/CapabilitiesPage';
import OnboardingPage from './components/OnboardingPage';
import Page from './common/Page';
import ScrollToTopOnMount from './components/ui/ScrollToTopOnMount';
import CookieBanner from './components/ui/CookieBanner';
import TermsOfService from './components/legal/TermsOfService';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import CookiesPolicy from './components/legal/CookiesPolicy';
import './App.css';

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="App min-h-screen">
          <ScrollToTopOnMount />
          <Routes>
            <Route path="/" element={<SEOOptimizedLandingPage />} />
            <Route path="/signup" element={<SignupForm />} />
            <Route path="/login" element={<LoginPage />} />

            {/* Marketing / service pages — wrapped in shared Page chrome (top nav + footer on every page) */}
            <Route path="/how-it-works" element={<Page><HowItWorksPage /></Page>} />
            <Route path="/editor" element={<Page><EditorDemoPage /></Page>} />
            <Route path="/compare" element={<Page><ComparePage /></Page>} />
            <Route path="/author-ai" element={<Page><AuthorAiPage /></Page>} />
            <Route path="/for-authors" element={<Page><ForAuthorsPage /></Page>} />
            <Route path="/about" element={<Page><AboutPage /></Page>} />
            <Route path="/analysis" element={<Page><AnalysisPage /></Page>} />
            <Route path="/try" element={<Page><TryPage /></Page>} />
            <Route path="/how-we-read-your-book" element={<Page><HowWeReadPage /></Page>} />
            <Route path="/author-persona" element={<Page><AuthorPersonaPage /></Page>} />
            <Route path="/authenticity" element={<Page><AuthenticityPage /></Page>} />
            <Route path="/writing-studio" element={<Page><WritingStudioPage /></Page>} />
            <Route path="/cover-studio" element={<Page><CoverStudioPage /></Page>} />
            <Route path="/cover-showcase" element={<Page><CoverGalleryPage /></Page>} />
            <Route path="/cover-gallery" element={<Navigate to="/cover-showcase" replace />} />
            <Route path="/api-docs" element={<Page><ApiDocsPage /></Page>} />
            <Route path="/book-previewer" element={<Page><BookPreviewerPage /></Page>} />
            <Route path="/book-marketing" element={<Page><SocialMarketingPage /></Page>} />
            <Route path="/marketing" element={<Navigate to="/book-marketing" replace />} />
            <Route path="/voice-dna" element={<Page><VoiceSamplesPage /></Page>} />
            <Route path="/voice-samples" element={<Navigate to="/voice-dna" replace />} />
            <Route path="/audiobook" element={<Page><AudiobookAddonPage /></Page>} />
            <Route path="/audiobook/acx" element={<Page><AudiobookACXPage /></Page>} />
            <Route path="/audiobook/voices" element={<Page><AudiobookVoicesPage /></Page>} />
            <Route path="/pricing" element={<Page><PricingPage /></Page>} />
            <Route path="/capabilities" element={<Page><CapabilitiesPage /></Page>} />
            <Route path="/agents" element={<Navigate to="/capabilities" replace />} />
            <Route path="/onboarding" element={<OnboardingPage />} />

            {/* Legal Routes */}
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiesPolicy />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
